import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const ConceptDetailsSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./ConceptDetailsSubForm"))
);
